import React, { Component } from 'react';

class Workflow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      urlProd: `https://extranet.vpn.atresmedia.com/a3wf/nuevaSolicitud.jsf?idServicio=94&idUsuario=${props.username}`,
      urlPre: `http://a3netpre/a3wf/a3wf/nuevaSolicitud.jsf?idServicio=94&idUsuario=${props.username}`
    };
  }

  render() {
    const prod = window.API_URL === 'https://intranetapi.atresmedia.com/';
    const { urlPre, urlProd } = this.state;

    return (
      <iframe
        title="workflow"
        id="workflowFrame"
        src={prod ? urlProd : urlPre}
        width="100%"
        height="100%"
        className="iframe-workflow"
      />
    );
  }
}
export default Workflow;
